module.exports = __webpack_public_path__ + "img/mobile/SmartButton-skip/btn-next-portrait-up@1x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/SmartButton-skip/btn-next-portrait-up@1x.png
// module id = 220
// module chunks = 0